import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/shared/Login'
import NewPassword from '@/components/shared/NewPassword'
import ChangeRole from '@/components/shared/ChangeRole'
import merchantRoutes from './merchant'
import npoRoutes from './npo'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      meta: {
        accessLevels: ['guest']
      },
      component: Login
    },
    {
      path: '/new-password',
      name: 'NewPassword',
      meta: {
        accessLevels: ['guest']
      },
      component: NewPassword
    },
    {
      path: '/change-role',
      name: 'ChangeRole',
      meta: {
        accessLevels: ['user', 'npo-admin', 'merchant-admin']
      },
      component: ChangeRole
    },
    ...merchantRoutes,
    ...npoRoutes
  ]
})

const canAccess = function(matchedRoutes, user) {
  return matchedRoutes.some(route => {
    return (
      !route.meta ||
      !route.meta.accessLevels ||
      route.meta.accessLevels.indexOf('guest') > -1 ||
      (user.loggedRole &&
        user.loggedRole.accessLevels &&
        route.meta.accessLevels.some(accessLevel => user.loggedRole.accessLevels.indexOf(accessLevel) > -1))
    )
  })
}

router.beforeEach((to, from, next) => {
  if (canAccess(to.matched, store.state.user)) {
    next()
  } else {
    next({
      path: '/',
      query: { redirect: to.fullPath }
    })
  }
  // next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js